import { createCouponsQuery } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useCouponsQuery = createCouponsQuery(HTTP_CONFIG.API.Consumer.url)
